// extracted by mini-css-extract-plugin
module.exports = {"input-group-wrapper":"styles_input-group-wrapper__URpz3","prefix":"styles_prefix__3cUCi","number":"styles_number__gSCZ9"};